import React, { useState } from 'react';
import { makeStyles, withStyles } from 'utils/makeStylesAdapter';
import {
  IconButton,
  Collapse,
  Typography,
  List,
  ListItem,
  ListItemText,
  Dialog,
  Divider,
  Box,
  ListItemIcon,
} from '@mui/material';
import MuiDialogTitle from '@mui/material/DialogTitle';
import ExpandLess from '@mui/icons-material/ExpandLess';
import ExpandMore from '@mui/icons-material/ExpandMore';
import PictureAsPdfIcon from '@mui/icons-material/PictureAsPdf';
import ListIcon from '@mui/icons-material/List';
import CloseIcon from '@mui/icons-material/Close';
import inquiryService from 'services/inquiries/inquiryService';
import { toast } from 'react-toastify';
import ClearIcon from '@mui/icons-material/Clear';
import { ModalConfirm } from 'components';

const styles = theme => ({
  root: {
    margin: 0,
    padding: theme.spacing(2),
  },
  closeButton: {
    position: 'absolute',
    right: theme.spacing(1),
    top: theme.spacing(1),
    color: theme.palette.grey[500],
  },
});

const DialogTitle = withStyles(styles)(props => {
  const { children, classes, onClose, ...other } = props;
  return (
    <MuiDialogTitle disableTypography className={classes.root} {...other}>
      <Typography variant="h3">{children}</Typography>
      {onClose ? (
        <IconButton aria-label="close" className={classes.closeButton} onClick={onClose}>
          <CloseIcon />
        </IconButton>
      ) : null}
    </MuiDialogTitle>
  );
});

const useStyles = makeStyles(theme => ({
  nested: {
    paddingLeft: theme.spacing(4),
  },
}));

const ModalListFiles = props => {
  const { onClose, open, files } = props;

  const classes = useStyles();

  const [openRequestDocument, setOpenRequestDocument] = useState(true);
  const [openResponseDocument, setOpenResponseDocument] = useState(true);
  const [openPjeIntegrationFiles, setOpenPjeIntegrationFiles] = useState(true);
  const [openPjeManifestationFiles, setOpenPjeManifestationFiles] = useState(true);

  const [selectedIndexRequest, setSelectedIndexRequest] = useState(null);
  const [selectedIndexResponse, setSelectedIndexResponse] = useState(null);
  const [filesArray, setFilesArray] = useState(files);
  const [openModalConfirmDelete, setOpenModalConfirmDelete] = useState(false);
  const [fileToDelete, setFileToDelete] = useState(null);

  const [loadingDeleteFile, setLoadingDeleteFile] = useState(false);

  const handleClose = () => {
    onClose();
  };

  const handleOpenRequest = () => {
    setOpenRequestDocument(!openRequestDocument);
  };

  const handleOpenResponse = () => {
    setOpenResponseDocument(!openResponseDocument);
  };

  const handleOpenPjeIntegration = () => {
    setOpenPjeIntegrationFiles(!openPjeIntegrationFiles);
  };

  const handleOpenPjeManifestation = () => {
    setOpenPjeManifestationFiles(!openPjeManifestationFiles);
  };

  const handleClearSelectedIndex = () => {
    setSelectedIndexResponse(null);
    setSelectedIndexRequest(null);
  };

  const handleDeleteFile = async () => {
    setLoadingDeleteFile(true);
    await inquiryService.deleteFilesInquiryService(fileToDelete);
    setOpenModalConfirmDelete(false);

    const fileIndexRequest =
      filesArray.requestDocument.findIndex(e => e.id === fileToDelete) !== -1;
    const fileIndexResponse =
      filesArray.responseDocument.findIndex(e => e.id === fileToDelete) !== -1;

    if (fileIndexRequest) {
      setFilesArray({
        ...filesArray,
        requestDocument: filesArray.requestDocument.filter(arquivo => arquivo.id !== fileToDelete),
      });
    } else if (fileIndexResponse) {
      setFilesArray({
        ...filesArray,
        responseDocument: filesArray.responseDocument.filter(
          arquivo => arquivo.id !== fileToDelete,
        ),
      });
    }
    setLoadingDeleteFile(false);
    toast.success('Arquivo excluído com sucesso!');
  };

  const openModalDelete = (inquiryFileId, event) => {
    event.stopPropagation();
    setFileToDelete(inquiryFileId);
    setOpenModalConfirmDelete(true);
  };

  const handleClick = (_event, file, index, list) => {
    switch (list) {
      case '1':
        setSelectedIndexResponse(null);
        setSelectedIndexRequest(index);
        break;
      case '2':
        setSelectedIndexResponse(index);
        setSelectedIndexRequest(null);
        break;
      default:
        break;
    }
    window.open(file.url, '_blank');
  };

  return (
    <Dialog
      onClose={handleClose}
      aria-labelledby="simple-dialog-title"
      open={open}
      fullWidth
      maxWidth="sm"
    >
      <DialogTitle onClose={handleClose} id="simple-dialog-title">
        Arquivos anexados
      </DialogTitle>
      <Divider />
      <List component="nav">
        <ListItem button onClick={handleOpenRequest}>
          <ListItemIcon>
            <ListIcon fontSize="small" />
          </ListItemIcon>
          <ListItemText primary="Arquivo de Solicitação" />
          {openRequestDocument ? <ExpandLess /> : <ExpandMore />}
        </ListItem>
        <Divider />
        {console.log({filesArray})}
        <Collapse in={openRequestDocument} timeout="auto" unmountOnExit>
          <List component="div" disablePadding>
            {filesArray.requestDocument.length > 0 ? (
              filesArray.requestDocument.map((file, index) => (
                <Box key={file.name}>
                  <ListItem
                    selected={selectedIndexRequest === index}
                    button
                    className={classes.nested}
                    onClick={event => handleClick(event, file, index, '1')}
                  >
                    <ListItemIcon>
                      <PictureAsPdfIcon fontSize="small" />
                    </ListItemIcon>
                    <ListItemText primary={file.name} />
                    <ListItemIcon>
                      <IconButton onClick={event => openModalDelete(file.id, event)}>
                        <ClearIcon fontSize="small" />
                      </IconButton>
                    </ListItemIcon>
                  </ListItem>
                  <Divider />
                </Box>
              ))
            ) : (
              <Box>
                <ListItem button className={classes.nested} onClick={handleClearSelectedIndex}>
                  <ListItemText primary="Não há arquivo" />
                </ListItem>
                <Divider />
              </Box>
            )}
          </List>
        </Collapse>
        <ListItem button onClick={handleOpenResponse}>
          <ListItemIcon>
            <ListIcon fontSize="small" />
          </ListItemIcon>
          <ListItemText primary="Arquivo de Resposta" />
          {openResponseDocument ? <ExpandLess /> : <ExpandMore />}
        </ListItem>
        {openResponseDocument && <Divider />}
        <Collapse in={openResponseDocument} timeout="auto" unmountOnExit>
          <List component="div" disablePadding>
            {filesArray.responseDocument.length > 0 ? (
              filesArray.responseDocument.map((file, index) => (
                <Box key={file.name}>
                  <ListItem
                    selected={selectedIndexResponse === index}
                    button
                    className={classes.nested}
                    onClick={event => handleClick(event, file, index, '2')}
                  >
                    <ListItemIcon>
                      <PictureAsPdfIcon fontSize="small" />
                    </ListItemIcon>
                    <ListItemText primary={file.name} />
                    <ListItemIcon>
                      <IconButton onClick={event => openModalDelete(file.id, event)}>
                        <ClearIcon fontSize="small" />
                      </IconButton>
                    </ListItemIcon>
                  </ListItem>
                  <Divider />
                </Box>
              ))
            ) : (
              <Box>
                <ListItem button className={classes.nested} onClick={handleClearSelectedIndex}>
                  <ListItemText primary="Não há arquivo" />
                </ListItem>
                <Divider />
              </Box>
            )}
          </List>
        </Collapse>
        {filesArray.pjeFiles?.length > 0 && (
          <>
            <ListItem button onClick={handleOpenPjeIntegration}>
              <ListItemIcon>
                <ListIcon fontSize="small" />
              </ListItemIcon>
              <ListItemText primary="Arquivo de integração automática com o PJE" />
              {openPjeIntegrationFiles ? <ExpandLess /> : <ExpandMore />}
            </ListItem>
            {openPjeIntegrationFiles && <Divider />}
            <Collapse in={openPjeIntegrationFiles} timeout="auto" unmountOnExit>
              <List component="div" disablePadding>
                {filesArray.pjeFiles.length > 0 ? (
                  filesArray.pjeFiles.map((file, index) => (
                    <Box key={file.name}>
                      <ListItem
                        selected={selectedIndexResponse === index}
                        className={classes.nested}
                        button
                        onClick={event => handleClick(event, file, index, '3')}
                      >
                        <ListItemIcon>
                          <PictureAsPdfIcon fontSize="small" />
                        </ListItemIcon>
                        <ListItemText primary={file.name} />
                      </ListItem>
                      <Divider />
                    </Box>
                  ))
                ) : (
                  <Box>
                    <ListItem button className={classes.nested} onClick={handleClearSelectedIndex}>
                      <ListItemText primary="Não há arquivo" />
                    </ListItem>
                    <Divider />
                  </Box>
                )}
              </List>
            </Collapse>
          </>
        )}
        {filesArray.pjeManifestation?.length > 0 && (
          <>
            <ListItem button onClick={handleOpenPjeManifestation}>
              <ListItemIcon>
                <ListIcon fontSize="small" />
              </ListItemIcon>
              <ListItemText primary="Arquivo de Resposta da integração automática com o PJE" />
              {openPjeManifestationFiles ? <ExpandLess /> : <ExpandMore />}
            </ListItem>
            {openPjeManifestationFiles && <Divider />}
            <Collapse in={openPjeIntegrationFiles} timeout="auto" unmountOnExit>
              <List component="div" disablePadding>
                {filesArray.pjeManifestation.length > 0 ? (
                  filesArray.pjeManifestation.map((file, index) => (
                    <Box key={file.name}>
                      <ListItem
                        selected={selectedIndexResponse === index}
                        className={classes.nested}
                        button
                        onClick={event => handleClick(event, file, index, '3')}
                      >
                        <ListItemIcon>
                          <PictureAsPdfIcon fontSize="small" />
                        </ListItemIcon>
                        <ListItemText primary={file.name} />
                      </ListItem>
                      <Divider />
                    </Box>
                  ))
                ) : (
                  <Box>
                    <ListItem button className={classes.nested} onClick={handleClearSelectedIndex}>
                      <ListItemText primary="Não há arquivo" />
                    </ListItem>
                    <Divider />
                  </Box>
                )}
              </List>
            </Collapse>
          </>
        )}
      </List>
      {openModalConfirmDelete && (
        <ModalConfirm
          title="Confirmação"
          open={openModalConfirmDelete}
          handleClose={() => {
            setOpenModalConfirmDelete(false);
            
          }}
          disabledConfirm={loadingDeleteFile}
          onClick={handleDeleteFile}
          noCloseOnConfirm={true}
        >
          <Typography variant="h5">Deseja excluir esse arquivo?</Typography>
        </ModalConfirm>
      )}
    </Dialog>
  );
};

export default ModalListFiles;
